// LICENSE_CODE ZON ISC
'use strict'; /*jslint node:true, browser:true*/
(function(){
var define;
var is_node = typeof module=='object' && module.exports && module.children;
var is_rn = (typeof global=='object' && !!global.nativeRequire) ||
    (typeof navigator=='object' && navigator.product=='ReactNative');
var is_ff_addon = typeof module=='object' && module.uri
    && !module.uri.indexOf('resource://');
if (is_rn)
    define = require('./require_node.js').define(module, '../');
else if (!is_node)
    define = self.define;
else
    define = require('./require_node.js').define(module, '../');
define(['/util/url.js'], function(url){
var E = {};
var EMAIL_PATTERN = '[a-z0-9_\\-+*]+(?:\\.[a-z0-9_\\-+*]+)*@(.+)';
var EMAIL_REGEX = new RegExp(EMAIL_PATTERN);
var ONLY_EMAIL_REGEX = new RegExp('^'+EMAIL_PATTERN+'$');

// WARNING: not exactly compatible with url.js:is_valid_email().
// If you need the is_signup flag, make E.email_parts() here and make a
// function somewhere else that contains the specific business logic for
// rejecting domains or alias components
E.is_valid = function(email){
    if (!email || typeof email!='string')
        return false;
    var n = email.toLowerCase().match(ONLY_EMAIL_REGEX);
    return !!(n && url.is_valid_domain(n[1]));
};

E.has_email = function(text){ return EMAIL_REGEX.test(text); };

E.get_req_email = function(req){
    return String(req.body.email||'').toLowerCase().trim();
};

E.get_user_from_email = function(email){
    var match = (email||'').toLowerCase().match(/^[a-z0-9_.\-+*%!]+(?=@)/);
    return match && match[0] || null;
};

// XXX josh: move the rest of the email functions from url.js

return E; }); }());
